import { z } from 'zod';

import { IS_SSR } from '@libs/common-next';

// A multi-word string with at least two space-separated words, allowing letters and specific punctuation (~, `, _, ', ,, -).
export const requesterNameRegEx = /^[\p{L}~`_',-]+(?: [\p{L}~`_',-]+)+$/u;

export const getJobFormFileSchema = (maxFileSize: number) => {
    const skusFileSchema = IS_SSR
        ? z.undefined()
        : z
              .object({
                  name: z.string().min(1, 'File name is required'),
                  type: z.string().refine(type => type === 'text/csv', {
                      message: 'Please upload a valid CSV file.',
                  }),
                  size: z
                      .number()
                      .positive('File size must be greater than 0')
                      .refine(size => size < maxFileSize, {
                          message: 'File size must be less than 2MB.',
                      }),
                  lastModified: z.number().optional(),
              })
              .or(
                  z
                      .custom<File>(file => file instanceof File && file.type === 'text/csv', {
                          message: 'Please upload a valid CSV file.',
                      })
                      .refine(file => file.size < maxFileSize, {
                          message: 'File size must be less than 2MB.',
                      })
              );

    return skusFileSchema;
};
